module.exports = __webpack_public_path__ + "img/devastation.0887f15c.jpg";